import { render, staticRenderFns } from "./Secretariat.vue?vue&type=template&id=61e62005&scoped=true&"
import script from "./Secretariat.vue?vue&type=script&lang=js&"
export * from "./Secretariat.vue?vue&type=script&lang=js&"
import style0 from "./Secretariat.vue?vue&type=style&index=0&id=61e62005&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e62005",
  null
  
)

export default component.exports